import classNames from 'classnames';
import { useState } from 'react';
import { Utils } from '../../../Common/Utils';
import { LabelBreadcrumbsActive } from '../components';
import { ExerciseDto, ExerciseVideoMetadataDto } from '../interfaces';
import {
    reportMediaFinished,
    reportMediaPaused,
    reportMediaStarted,
} from '../exerciseAPI';

type Props = {
    hideDuration?: boolean;
    exercise: ExerciseDto;
    videoMetadata?: ExerciseVideoMetadataDto;
    onStartPlaying?: () => void;
    onVideoEnded?: () => void;
    className?: string;
    style?: React.CSSProperties;
};
export function VideoExerciseView({
    hideDuration = false,
    exercise,
    videoMetadata = exercise.VideoMetadata,
    onStartPlaying,
    onVideoEnded,
    className,
    ...props
}: Props) {
    const moduleId = exercise.ModuleId;
    const exerciseId = { Value: exercise.Id };

    const [isStarted, setIsStarted] = useState(false);
    return (
        <div className={classNames(className, 'relative')} {...props}>
            <video
                controls
                onPlay={(e) => {
                    const currentTime = e.currentTarget.currentTime;
                    reportMediaStarted(
                        moduleId,
                        exerciseId,
                        videoMetadata.VideoUrl,
                        currentTime,
                    );

                    setIsStarted(true);
                    onStartPlaying?.();
                }}
                onPause={(e) => {
                    const currentTime = e.currentTarget.currentTime;
                    const durationInSeconds = Utils.timeSpanStringToSeconds(
                        videoMetadata.Duration,
                    );
                    const pauseBuffer = 2;
                    if (currentTime + pauseBuffer < durationInSeconds) {
                        reportMediaPaused(
                            moduleId,
                            exerciseId,
                            videoMetadata.VideoUrl,
                            currentTime,
                        );
                    } else {
                        reportMediaFinished(
                            moduleId,
                            exerciseId,
                            videoMetadata.VideoUrl,
                        );
                    }
                }}
                onEnded={() => {
                    onVideoEnded?.();
                }}
                poster={videoMetadata.PosterUrl}
                className="rounded-[10px]"
            >
                <source
                    src={videoMetadata.VideoUrl}
                    type={videoMetadata.MimeType}
                />
            </video>
            {!hideDuration &&
                !isStarted &&
                (Utils.isIos() || Utils.isSafari) && (
                    <LabelBreadcrumbsActive class="absolute bottom-5 right-5 ml-10 rounded bg-dark-grey px-5 text-white">
                        {Utils.formatTimespan(videoMetadata.Duration)}
                    </LabelBreadcrumbsActive>
                )}
        </div>
    );
}
